import { InvoiceItem } from "../Type"

/**
 * Format currency amount from DB to display on UI.
 * Note: Currency amount is saved in DB by multiplying by 100
 * to preserve coin fraction e.g., 100.25 is saved as 10025 in DB.
 *
 * @param amount e.g., 1025
 * @returns e.g., 10.25
 */
export const formatCurrencyAmount = (amount: number): number => {
  if (amount) {
    return parseFloat((amount / 100).toFixed(2))
  } else {
    return 0
  }
}

export const getTotalPrice = (invoiceItems: InvoiceItem[]) => {
  let totalPrice = 0
  for (let item of invoiceItems) {
    totalPrice += item.totalPrice
  }
  return totalPrice
}
